module.exports = __webpack_public_path__ + "img/messages-icon.1b88cb8d.svg";